import {Component } from 'preact';

import Helmet from "preact-helmet";

import { route } from 'preact-router';

// add prev/next somehow

class SongPage extends Component {
  constructor(props) {
    super(props)

    this.state = {
			song: null,
			songs: []
    }
  }

	componentDidMount() {
		const { sanity, matches } = this.props
		const { slug } = matches

    const query = '*[_type == "song"]{ album_art, title,_id,"image": image.asset->url, "slug": slug.current, platforms, release }'

		sanity.fetch(query, {slug})
    .then((items) => {
			const songs = items.filter(c => c.slug)
			const song = songs.find(c => c.slug === slug)


			this.setState({song: song || {}, songs})
		})
	}

	componentWillReceiveProps(nextProps) {
		if (this.props.matches.slug !== nextProps.matches.slug) {
			const nextSong = this.state.songs.find(s => s.slug === nextProps.matches.slug)

			if (nextSong) {
				this.setState({song: nextSong })
			}
		}
	}

	changeActive = change => {
		// const records = this.state.records.filter(record => record.id.kind !=='youtube#playlist')
		const { song, songs } = this.state
		const sorted = songs.sort((a, b) => (a.release || '0') < (b.release || '0') ? 1 : -1)
		const index = sorted.findIndex(s => s._id === song._id)
		let nextIndex = index + change

		if (nextIndex === songs.length) {
			nextIndex = 0
		} else if (nextIndex === -1) {
			nextIndex = songs.length - 1
		}
	
		const nextSong = sorted[nextIndex]

		route('/'+ nextSong.slug)
	}

  render ({},  { song }) {

		return (
      <section className="">
  
				
				<div class="songpage ">
					<div class="songpgage item">
					
					
							{song && <div>
								{/* <Helmet
					htmlAttributes={{lang: "en", amp: undefined}} // amp takes no value
					title={song.title}
						titleTemplate="%s" /> */}
								<div class="col-6 left">
							
						{song.album_art && <img  src={song.album_art}  />}
								</div>
							<div class="col-6 left">
							<h3 class="songTitle">{song.title}</h3>
								{song.platforms && 
									<div class="plats">
										{song.platforms.map((platform, i) =>
											<div class="ins" key={i}>
												<a href={platform.source_url} target="__blank" >
												{/* <img src={"https://tecca-btns.now.sh/"+ "btn-"+ platform.platform_name + ".png" } />   */}
												{platform.platform_name}
												</a>
											</div>
										)}
									</div>
								}
								<div class="nxtprv">
							<button onClick={() => this.changeActive(-1)} >Prev</button>
							<button onClick={() => this.changeActive(1)} >Next</button>
						</div>
								</div>
							</div>
						 }
						
					</div>
					
				</div>
				<div class="clearfix"></div>
      </section>
    )
  }
}

export default SongPage






// WEBPACK FOOTER //
// ./routes/song-page/index.js